import { useMemo } from "react";
import axios from "axios";
import { getAuthUrl, getPropelAPI } from "@fuse/utils/environement";

const apiKey = getPropelAPI();

export const usePropelUser = () => {
  const baseUrl = getAuthUrl();

  const propelAxios = useMemo(() => {
    return axios.create({
      baseURL: `${baseUrl}/api/backend/v1`, // Ensure the base URL includes the API prefix
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json", // Explicitly set content type
      },
    });
  }, [baseUrl, apiKey]);

  // Add user-specific methods
  const getUser = async (userId, includeOrgs = false) => {
    try {
      const response = await propelAxios.get(`/user/${userId}`, {
        params: includeOrgs ? { includeOrgs: true } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  };

  // Return axios instance with additional getUser method
  return Object.assign(propelAxios, { getUser });
};
